var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "time-sandglass"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 19.6848C4 20.6873 4.81269 21.5 5.81518 21.5H18.1848C19.1873 21.5 20 20.6873 20 19.6848H4Z",
    fill: "#AAA4B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L17.2242 9.06139C18.9389 8.09689 20 6.28252 20 4.31518H4C4 6.28252 5.06113 8.09688 6.77581 9.06139L12 12Z",
    fill: "#AAA4B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L17.2242 9.06139C18.9389 8.09689 20 6.28252 20 4.31518M12 12L6.77581 9.06139C5.06113 8.09688 4 6.28252 4 4.31518M12 12L6.77581 14.9386C5.06113 15.9031 4 17.7175 4 19.6848M12 12L17.2242 14.9386C18.9389 15.9031 20 17.7175 20 19.6848M20 4.31518C20 3.31269 19.1873 2.5 18.1848 2.5H5.81518C4.81269 2.5 4 3.31269 4 4.31518M20 4.31518H4M4 19.6848C4 20.6873 4.81269 21.5 5.81518 21.5H18.1848C19.1873 21.5 20 20.6873 20 19.6848M4 19.6848H20",
    stroke: "#675D75",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.51fd78c3ff30a00da4aadff9685aa011.svg";
export { ForwardRef as ReactComponent };